<template>
  <v-main>
    <router-view />
    <v-snackbar
      v-model="snackbarActive"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      top
      right
      style="margin-top:64px">
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text @click="dispatchSnackbarAction" v-bind="attrs">{{ snackbarActionText }}</v-btn>
      </template>
    </v-snackbar>
  </v-main>
</template>
<style>
/* div.v-application.theme--light main.v-main {
  background-color: #dcdcdc;
} */
.fadeSlideLeft-enter {
  opacity: 0;
  transform: translateX(-5%)
}
.fadeSlideLeft-enter-to, .fadeSlideLeft-leave-from {
  opacity: 1;
  transform: translateX(0)
}
.fadeSlideLeft-enter-active, .fadeSlideLeft-leave-active {
  transition: all .2s ease-in-out;
}
.fadeSlideLeft-leave-to {
  opacity: 0;
  transform: translateX(-5%)
}
.slide-enter {
  opacity: 0;
  transform: translateX(100%);
  position:absolute;
}
.slide-enter-to, .slide-leave-from {
  opacity: 1;
  transform: translateX(0);
}
.slide-enter-active, .slide-leave-active {
  transition: all .3s ease-in-out;
}
.slide-leave-to {
  position:absolute;
  opacity: 0;
  transform: translateX(-100%)
}
</style>
<script>
import { computed } from '@vue/composition-api'
export default {
  setup (props, { root }) {
    const snackbar = computed({
      get: () => root.$store.state.snackbar,
      set: (val) => root.$store.dispatch('snackbar', val)
    })
    const snackbarActive = computed({
      get: () => snackbar.value.active,
      set: (val) => { snackbar.value.active = val }
    })

    const snackbarActionText = computed(() => {
      if ('actionText' in snackbar.value && snackbar.value.actionText !== '' && 'action' in snackbar.value && snackbar.value.action !== '') {
        return snackbar.value.actionText
      } else {
        return 'Dismiss'
      }
    })

    function dispatchSnackbarAction () {
      if ('action' in snackbar.value && 'actionText' in snackbar.value && snackbar.value.action !== '' && snackbar.value.actionText !== '') {
        if (snackbar.value.action.substr(0, 3) === 'to:') {
          root.$router.push(snackbar.value.action.substr(3))
        } else if (snackbar.value.action.substr(0, 7) === 'http://' || snackbar.value.action.substr(0, 8) === 'https://') {
          window.open(snackbar.value.action, snackbar.value.actionText)
        } else {
          root.$store.dispatch(snackbar.value.action)
        }
      }
      root.$store.dispatch('snackbar', { active: false })
    }

    return {
      snackbar,
      snackbarActive,
      snackbarActionText,
      dispatchSnackbarAction
    }
  }
}
</script>
